export const TransactionGroupByType = {
    locations: "locations",
    users: "users",
    chargeTokens: "chargeCards"
};